var de = require('apexcharts/dist/locales/de.json')
var en = require('apexcharts/dist/locales/en.json')
var hr = require('apexcharts/dist/locales/hr.json')
var ru = require('apexcharts/dist/locales/ru.json')
var es = require('apexcharts/dist/locales/es.json')
var tr = require('apexcharts/dist/locales/tr.json')
var cs = require('apexcharts/dist/locales/cs.json')

// bg.json ne postoji u apexcharts paketu, kreiramo ga ručno
const bg = {
  name: 'bg',
  options: {
    months: ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'],
    shortMonths: ['Яну', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ноем', 'Дек'],
    days: ['Неделя', 'Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота'],
    shortDays: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    toolbar: {
      exportToSVG: 'Изтегляне като SVG',
      exportToPNG: 'Изтегляне като PNG',
      exportToCSV: 'Изтегляне като CSV',
      menu: 'Меню',
      selection: 'Избор',
      selectionZoom: 'Избор на мащаб',
      zoomIn: 'Увеличаване',
      zoomOut: 'Намаляване',
      pan: 'Панорамиране',
      reset: 'Възстановяване на мащаба'
    }
  }
}

export const ApexChartsLocale = [
  de,
  en,
  hr,
  ru,
  es,
  tr,
  cs,
  bg
]
